import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'


import { BlacklistTableUI } from './BlacklistTableUI'
import {BlacklistSearchForm} from './BlacklistSearchForm'

//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class BlacklistTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetBlackList?offset=";
    this.getExcelUrl = "/api/v1/GetBlackListReportExcel";

  

    this.className = "ChanceReport";
    this.state.mode = "table";
    this.state.searchData = { };
    this.headers["ceremonyId"] = this.props.ceremonyId;


  }


  render() {
    //  if (!this.state.isLoaded) {
    //  return <div className="box-body"> در حال بارگذاری</div>;
    // }

    //console.log()

    return (
      <div className="container">

        <BlacklistSearchForm onSubmit={this.onSubmitSearchData} searchData={this.state.searchData} />
        <br/>
        <BlacklistTableUI data={this.state.data} onViewClick={this.onViewClick} />
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/tables/blacklist/BlacklistTable.js